import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-service-order-invoice-form',
    templateUrl: './service-order-invoice-form.component.html',
    styleUrl: './service-order-invoice-form.component.scss'
})
export class ServiceOrderInvoiceFormComponent implements OnInit {

    @Input() public invoiceNumber = '';
    @Input() public editMode = false;

    public invoiceForm!: FormGroup;

    // validators min/max rules
    public invoiceMinLength = 3;
    public invoiceMaxLength = 60;

    constructor(private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.buildInvoiceForm();
        if (this.invoiceNumber) this.invoice.setValue(this.invoiceNumber);
    }

    public get invoice(): AbstractControl {
        return this.invoiceForm.controls['invoice'];
    }

    private buildInvoiceForm(): void {
        this.invoiceForm = this.formBuilder.group({
            invoice: ['', {
                validators: [
                    Validators.minLength(this.invoiceMinLength), Validators.maxLength(this.invoiceMaxLength)]
            }],
        });
    }
}
